type stateT = {
  +asError: boolean,
  +errorMessage: string,
  +loading: boolean,
  +stats: Array<{ date: number, value: number }>,
  +total: number,
  +period: string,
  +queryId: string,
};

// ACTIONS
type filterT = { period: string, redirectId: string };
type errorT = { message: string };
export type actionT =
  | { type: 'LOAD_REDIRECT_STATS', filter: filter, queryId: string }
  | {
      type: 'LOAD_REDIRECT_STATS_SUCCESS',
      data: redirectStatsT,
      queryId: string,
    }
  | { type: 'LOAD_REDIRECT_STATS_ERROR', error: error, queryId: string };

export function loadRedirectStats(filter: filterT, queryId: string): actionT {
  return {
    type: 'LOAD_REDIRECT_STATS',
    filter,
    queryId,
  };
}

export function loadRedirectStatsSuccess(data: redirectStatsT, queryId: string): action {
  return {
    type: 'LOAD_REDIRECT_STATS_SUCCESS',
    data,
    queryId,
  };
}

export function loadRedirectStatsError(error: errorT, queryId: string): actionT {
  return {
    type: 'LOAD_REDIRECT_STATS_ERROR',
    error,
    queryId,
  };
}

// STORE
const initialRedirectsState: stateT = {
  asError: false,
  errorMessage: '',
  loading: true,
  stats: [],
  total: -1,
  redirectId: '',
  period: '',
  queryId: '',
};

export function abRedirectStats(state: stateT = initialRedirectsState, action: actionT): state {
  switch (action.type) {
    case 'LOAD_REDIRECT_STATS':
      const { redirectId, period } = action.filter;
      const { queryId } = action;

      return {
        ...state,
        redirectId,
        period,
        queryId,
        loading: true,
        stats: [],
        total: -1,
      };
    case 'LOAD_REDIRECT_STATS_SUCCESS':
      if (state.queryId === action.queryId) {
        const { stats } = action.data;

        let total = 0;

        stats.forEach((s) => (total += s.value));

        return {
          ...state,
          loading: false,
          stats,
          total,
        };
      }

      return state;
    case 'LOAD_REDIRECT_STATS_ERROR':
      if (state.queryId === action.queryId) {
        return {
          ...state,
          loading: false,
          asError: true,
          errorMessage: action.error.message,
        };
      }

      return state;
    default:
      return state;
  }
}
